var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_75_2",
    "data-name": "Componente 75 \\u2013 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_273",
    "data-name": "Rect\\xE1ngulo 273",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filter_alt_FILL0_wght300_GRAD0_opsz40",
    d: "M191.713-767.745a.7.7,0,0,1-.515-.207.7.7,0,0,1-.207-.515V-773.2l-4.642-5.9a.5.5,0,0,1-.064-.59.538.538,0,0,1,.508-.312h10.847a.538.538,0,0,1,.508.312.5.5,0,0,1-.064.59l-4.642,5.9v4.729a.7.7,0,0,1-.207.515.7.7,0,0,1-.515.207h-1.005Zm.5-5.561,4.464-5.666h-8.928ZM192.216-773.307Z",
    transform: "translate(-184.215 781.998)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltro);
export default __webpack_public_path__ + "static/media/filtro.1a8902e76a5a8efaa948475c0096becf.svg";
export { ForwardRef as ReactComponent };